<template>
  <div>
    <!-- À deplacer
    <pageTop/>
    -->
    <v-container class="page-top">
      <pageTitle/>
      <testButtons
          @start-test="startTest"
          @end-test="endTest"
      />
      <resultButtons
          v-if="testOn"
          :data=Tests
      />
    </v-container>
    <!-- fin déplacement -->
    <v-container class="accordion">
      <!-- faire un component de cette partie !!!
      avec tout le code des tests et les fonctions externes -->
      <testItem
          v-for="(item, index) in Tests"
          :key=index
          :index=index
          :nom=item.nom
          :testId=item.id
          :icon=item.icon
          :testOk=item.ok
          :testWarn=item.warn
          :testError=item.erreur
          :testHide=item.hide
          :testOn=item.on
          :message=item.message
          :arrow=item.arrow
          :speed=speed.data
          @run-individual-test="runIndividualTest"
          @show-text="showText"
      />
      <!--
      <p>{{ t }}</p>
      <p>
        <BaseButton class="test-button" @click="worker_test">Test worker</BaseButton>
        <span>{{ testRes }}</span>
      </p>
      <p>{{ Object.keys(t) }}</p>
      <p v-for="(item, index) in t" :key=index :name=item.nom>
        {{ Object.keys(item) }}
        {{ item.a }}
        <span v-for="(it, ind) in item" :key=ind :name=it>{{ it }}</span>
      </p>
      -->
      <tryBBB :testOn="testOn" :testBBB="Tests[5].on" />
    </v-container>
  </div>
</template>

<script>
import testButtons from "../components/top/testButtons"
import testItem from "@/components/testItem"
import resultButtons from "../components/top/resultButtons"
import pageTitle from "../components/top/pageTitle"
import tryBBB from "../components/mainTests/tryBBB"

import TestBBBDataService from "../services/TestBBBDataService"
import Bowser from "bowser"
import ping from "web-pingjs"
import supportedBrowsers from "../services/isIE"
import isIE from "../services/isIE"
import Speedtest from "../services/speedtest"
import BBBtests from "../services/bbbtests"
import TryBBB from "../components/mainTests/tryBBB"
//import BaseButton from "../components/BaseButton";
//import testUA from "browserslist-useragent"

export default {
  name: 'testBBB',

  components: {
    TryBBB,
    //BaseButton,
    resultButtons,
    testItem,
    testButtons,
    pageTitle,
    tryBBB,
  },

  data: function () {
    return {
      testsBBB: new BBBtests(),
      testRes: "aaa",
      speed: {
        test: new Speedtest(),
        data: {
          dlStatus: "",
          dlProgress: "",
          ulStatus: "",
          ulProgress: "",
          ping: "",
          jitter: "",
          clientIp: "",
        },
        server: {	//this is my demo server, remove it
          name: "SERVEUR DE TEST BBB", //user friendly name for the server
          //server: "http://localhost:3000/api/speedtests", //URL to the server. // at the beginning will be replaced with http:// or https:// automatically
          //server: "https://page-bbb-test.di.unistra.fr/api/speedtests",
          //server: "https://test-bbb.unistra.fr/api/speedtests",
          server: process.env.VUE_APP_PROTO_BACK + process.env.VUE_APP_SERVEUR_BACK + process.env.VUE_APP_SPEED_API,
          dlURL: "poubelle",  //path to download test on this server (garbage.php or replacement)
          ulURL: "vide",  //path to upload test on this server (empty.php or replacement)
          pingURL: "vide",  //path to ping/jitter test on this server (empty.php or replacement)
          getIpURL: "ip"  //path to getIP on this server (getIP.php or replacement)
        },
      },

      testOn: false,
      video: "",
      translateTest: "",
      a: {type: "us", img: "us-notebook", size: 2,},
      t: {
        nav: {
          nom: "ab",
          ab: "AB",
          a: this.a,
        },
        micro: {
          nom: "bc",
          bc: "BC",
          a: this.a,
        },
        cam: {
          nom: "cd",
          cd: "CD",
          a: this.a,
        },
        conn: {
          nom: "de",
          de: "DE",
          a: this.a,
        },
      },
      Tests: [
        {
          nom: "Navigateur",
          id: "browser",
          icon: {
            type: "us",
            img: "us-windows",
            size: "sm us-3x",
          },
          arrow: {
            type: "us",
            img: "us-arrow-right",
            size: 2,
          },
          ok: false,
          warn: false,
          erreur: false,
          hide: true,
          message: "",
          on: false
        },
        {
          nom: "Micro",
          id: "micro",
          icon: {
            type: "nv",
            img: "nv-wave",
            size: "3x",
          },
          arrow: {
            type: "us",
            img: "us-arrow-right",
            size: 2,
          },
          ok: false,
          warn: false,
          erreur: false,
          hide: true,
          message: "",
          on: false
        },
        {
          nom: "Cam",
          id: "webcam",
          icon: {
            type: "nv",
            img: "nv-video-camera",
            size: "3x",
          },
          arrow: {
            type: "us",
            img: "us-arrow-right",
            size: 2,
          },
          ok: false,
          warn: false,
          erreur: false,
          hide: true,
          message: "",
          on: false
        },
        {
          nom: "Sortie Audio",
          id: "audio_output",
          icon: {
            type: "nv",
            img: "nv-speaker-volume-medium",
            size: "3x",
          },
          arrow: {
            type: "us",
            img: "us-arrow-right",
            size: 2,
          },
          ok: false,
          warn: false,
          erreur: false,
          hide: true,
          message: "",
          on: false
        },
        {
          nom: "Connexion",
          id: "network",
          icon: {
            type: "us",
            img: "us-wifi",
            size: "sm us-3x",
          },
          arrow: {
            type: "us",
            img: "us-arrow-right",
            size: 2,
          },
          ok: false,
          warn: false,
          erreur: false,
          hide: true,
          message: "",
          on: false
        },
        {
          nom: "Video",
          id: "video",
          icon: {
            type: "nv",
            img: "nv-video-call",
            size: "3x",
          },
          arrow: {
            type: "us",
            img: "us-arrow-right",
            size: 2,
          },
          ok: false,
          warn: false,
          erreur: false,
          hide: true,
          message: "",
          on: false
        }
      ],
    }
  },

  beforeDestroy() {
    this.endTest()
  },

  methods: {
    worker_test() {
      console.log(this.testsBBB.getState())
      this.testsBBB.onmessage = function (data) {
        this.testRes = data
      }.bind(this)
      this.testsBBB.browser()
    },

    startTest() {
      this.endTest()
      for (let i = 0; i < this.Tests.length; i++) {
        this.runIndividualTest(i)
      }
    },

    endTest() {
      if (this.speed.test.getState() == 3) {
        this.speed.test.abort()
      }
      this.clearResults(-1)
      this.testOn = false
    },

    showText(index) {
      this.Tests[index].hide = !this.Tests[index].hide
      if (this.Tests[index].hide) {
        this.Tests[index].arrow.img = "us-arrow-right"
      } else {
        this.Tests[index].arrow.img = "us-arrow-bottom"
      }
    },

    saveToDB() {
      let res = {
        description: 'Test complet',
        clientIP: this.Tests[4].message,
        result: this.Tests[0].message
      }
      TestBBBDataService.postResult(res).then(a => {
        console.log(a.data)
      }).catch(e => {
        console.log(e)
      })
    },

    supportedBrowser(UA) {
      //let test1 = testUA.matchesUA(UA)
      let test2 = supportedBrowsers.test(UA) //|| test1
      return test2
    },

    isExplorer(UA) {
      return isIE.test(UA)
    },

    decodeError(error) {
      switch (error.name) {
        case 'AbortError':
          return "Bien que l'utilisateur et le système d'exploitation aient tous deux accédé à l'équipement matériel, et qu'aucun problème de matériel ne causerait un NotReadableError , un problème s'est produit, ce qui a empêché l'utilisation du périphérique."
        case 'NotAllowedError':
          return "Il n'y a pas d'autorisation"
        case 'NotFoundError':
          return "Aucune piste multimédia du type spécifié n'a été trouvée satisfaisant les contraintes données."
        case 'NotReadableError':
          return "Bien que l'utilisateur ait autorisé l'utilisation des appareils correspondants, une erreur matérielle s'est produite sur le système d'exploitation, le navigateur ou le niveau de la page Web qui a empêché l'accès au périphérique."
        case 'OverConstrainedError':
          return "Aucun dispositif candidat répondant aux critères demandés. L'erreur est un objet de type OverconstrainedError et possède une propriété de constraint dont la valeur de chaîne est le nom d'une contrainte impossible à honorer et une propriété message contenant une chaîne lisible par l'homme expliquant le problème."
        case 'SecurityError':
          return "Le support multimédia utilisateur est désactivé sur le Document sur lequel getUserMedia() été appelé. Le mécanisme par lequel le support média utilisateur est activé/désactivé est laissé à la discrétion de l'utilisateur."
        case 'TypeError':
          return "La liste des contraintes spécifiées est vide ou toutes les contraintes sont définies comme false."
        case 'NetworkError':
          return "Erreur réseau"
        case 'TimeoutError':
          return "Le temps est dépassé"
        default:
          return error.name + ' ' + error.message
      }
    },

    runIndividualTest(index) {
      if (!this.testOn) {
        this.testOn = true
      }
      this.clearResults(index)
      this.showText(index)
      this.Tests[index].on = true
      this.Tests[index].message = this.$t("testBBB.testRunning")
      switch (this.Tests[index].nom) {
        case 'Navigateur':
          this.testNav()
              .then(infosNav => {
                console.log(infosNav.UA)
                this.Tests[0].message = infosNav.curOS.browser.name + "-" + infosNav.curOS.browser.version + "-" + infosNav.curOS.os.name + "-" + infosNav.curOS.platform.type
                if (!this.supportedBrowser(infosNav.UA)) {
                  this.Tests[0].ok = true
                  this.Tests[0].warn = false
                  this.Tests[0].erreur = false
                } else {
                  //if (this)
                  throw({name: "Warning", message: infosNav})
                }
              })
              .catch(error => {
                switch (error.name) {
                  case "Warning": {
                    this.Tests[0].message = error.message.curOS.browser.name + "-" + error.message.curOS.browser.version + "-" + error.message.curOS.os.name + "-" + error.message.curOS.platform.type
                    this.Tests[0].ok = false
                    this.Tests[0].warn = true
                    this.Tests[0].erreur = false
                    break
                  }
                  default: {
                    this.Tests[0].message = error.message
                    this.Tests[0].ok = false
                    this.Tests[0].warn = false
                    this.Tests[0].erreur = true
                    break
                  }
                }
              })
          break
        case 'Micro':
          if (!this.Tests[0].warn & this.Tests[0].on) {
            this.testMateriel(true, false, 'i')
                .then(listeAudio => {
                  this.Tests[1].message = listeAudio
                  this.Tests[1].ok = true
                  this.Tests[1].warn = false
                  this.Tests[1].erreur = false
                })
                .catch(error => {
                  this.Tests[1].message = this.decodeError(error)
                  this.Tests[1].ok = false
                  this.Tests[1].warn = false
                  this.Tests[1].erreur = true
                })
          } else {
            this.Tests[1].on = false
            this.Tests[1].ok = false
            this.Tests[1].warn = true
            this.Tests[1].erreur = false
          }
          break
        case 'Cam':
          if (!this.Tests[0].warn & this.Tests[0].on) {
            this.testMateriel(false, true, 'i')
                .then(listeVideo => {
                  this.Tests[2].message = listeVideo
                  this.Tests[2].ok = true
                  this.Tests[2].warn = false
                  this.Tests[2].erreur = false
                })
                .catch(error => {
                  this.Tests[2].message = this.decodeError(error)
                  this.Tests[2].ok = false
                  this.Tests[2].warn = false
                  this.Tests[2].erreur = true
                })
          } else {
            this.Tests[2].on = false
            this.Tests[2].ok = false
            this.Tests[2].warn = true
            this.Tests[2].erreur = false
          }
          break
        case 'Sortie Audio':
          if (!this.Tests[0].warn & this.Tests[0].on) {
            this.testMateriel(true, false, 'o')
                .then(listeSortieAudio => {
                  this.Tests[3].message = listeSortieAudio
                  this.Tests[3].ok = true
                  this.Tests[3].warn = false
                  this.Tests[3].erreur = false
                })
                .catch(error => {
                  this.Tests[3].message = this.decodeError(error)
                  this.Tests[3].ok = false
                  this.Tests[3].warn = false
                  this.Tests[3].erreur = true
                })
          } else {
            this.Tests[3].on = false
            this.Tests[3].ok = false
            this.Tests[3].warn = true
            this.Tests[3].erreur = false
          }
          break
        case 'Connexion':
          if (!this.Tests[0].warn & this.Tests[0].on) {
            this.testConnexion()
                .then(connexion => {
                  console.log(connexion)
                  this.Tests[4].message = connexion
                  this.Tests[4].ok = true
                  this.Tests[4].warn = false
                  this.Tests[4].erreur = false
                })
                .catch(error => {
                  this.Tests[4].message = this.decodeError(error)
                  this.Tests[4].ok = false
                  this.Tests[4].warn = false
                  this.Tests[4].erreur = true
                })
          } else {
            this.Tests[4].on = false
            this.Tests[4].ok = false
            this.Tests[4].warn = true
            this.Tests[4].erreur = false
          }
          break
        case 'Video':
          /*sur Moodle, actuellement, l'URL du serveur utilisé par le plugin est https://bbb-prod-rp.unistra.fr/bigbluebutton/*/
          if (!this.Tests[0].warn & this.Tests[0].on) {
            this.testCamMicro()
                .then(() => {
                  this.Tests[5].message = ""
                  this.Tests[5].ok = true
                  this.Tests[5].warn = false
                  this.Tests[5].erreur = false
                })
                .catch(error => {
                  this.Tests[5].message = this.decodeError(error)
                  this.Tests[5].ok = false
                  this.Tests[5].warn = false
                  this.Tests[5].erreur = true
                })
          } else {
            this.Tests[5].on = false
            this.Tests[5].ok = false
            this.Tests[5].warn = true
            this.Tests[5].erreur = false
          }
          break
        default:
          console.log('Pas de test') //Il ne devrait jamais afficher ceci
      }
    },

    clearResults(index) {
      let start, end
      if (index == -1) {
        start = 0
        end = this.Tests.length
      } else {
        start = index
        end = index + 1
      }
      for (let i = start; i < end; i++) {
        if (i == 5) {
          this.testCamMicroFin()
        }
        if (i == 4) {
          this.speed.test = new Speedtest()
        }
        this.Tests[i].message = ""
        this.Tests[i].ok = false
        this.Tests[i].warn = false
        this.Tests[i].erreur = false
        this.Tests[i].hide = true
        this.Tests[i].on = false
        this.Tests[i].arrow.img = "us-arrow-right"
      }
    },

    getUA() {
      return TestBBBDataService.getUA()
          .then(response => {
            return response.data.user
          })
          .catch(error => {
            throw error
          })
    },

    testPing() {
      let lien = new URL(process.env.VUE_APP_PROTO_BACK + process.env.VUE_APP_SERVEUR_BACK + process.env.VUE_APP_API)
      return ping(lien).then(delta => {
        return (String(delta))
      }).catch(function (error) {
        throw error
      })
    },

    testIP() {
      return TestBBBDataService.getIP()
          .then(adresseIP => {
            return TestBBBDataService.getIP2(adresseIP.data.adresse)
                .then(response => {
                  console.log(response)
                  if (!response.data.bogon) {
                    return response.data.ip + '-' + response.data.org.replace(/^AS\d*\s/i, '')
                  } else {
                    return 'IP locale - Opérateur inconnu'
                  }
                })
                .catch(error => {
                  throw error
                })
          })
          .catch(error => {
            throw error
          })
    },

    testSpeed() {
      return new Promise((resolve, reject) => {
        if (this.speed.test.getState() == 0) {
          this.speed.test.setSelectedServer(this.speed.server)

          this.speed.test.onupdate = function (data) { // when status is received, put the values in the appropriate fields
            this.speed.data.dlStatus = data.dlStatus + ' Mbit/s'
            this.speed.data.dlProgress = Math.floor(Number(data.dlProgress) * 100)
            this.speed.data.ulStatus = data.ulStatus + ' Mbit/s'
            this.speed.data.ulProgress = Math.floor(Number(data.ulProgress) * 100)
            this.speed.data.ping = data.pingStatus + ' ms'
            this.speed.data.jitter = data.jitterStatus + ' ms'
            this.speed.data.clientIp = data.clientIp
          }.bind(this)

          this.speed.test.onend = function (data) {
            if (data) {
              reject()
            } else {
              resolve()
            }
          }.bind(this)
        }
        this.speed.test.start()
      })
    },

    testConnexion() {
      let testsConnexion = [this.testPing(), this.testIP(), this.testSpeed()]
      console.log(testsConnexion)
      return Promise.all(testsConnexion)
          .then((result) => {
            return result.join('-')
          })
          .catch(error => {
            throw error
          })
    },

    testMateriel(audio, video, io) {
      return navigator.mediaDevices.getUserMedia({"audio": audio, "video": video})
          .then(function (temp) {
            return navigator.mediaDevices.enumerateDevices()
                .then(function (devices) {
                  let listDevices = ""
                  devices.forEach(function (device) {
                    if (device.kind === 'audioinput' && audio && io === 'i') {
                      if (listDevices === "") {
                        listDevices += (device.label)
                      } else {
                        listDevices += (', ' + device.label)
                      }
                    }
                    if (device.kind === 'audiooutput' && audio && io === 'o') {
                      if (listDevices === "") {
                        listDevices += (device.label)
                      } else {
                        listDevices += (', ' + device.label)
                      }
                    }
                    if (device.kind === 'videoinput' && video && io === 'i') {
                      if (listDevices === "") {
                        listDevices += (device.label)
                      } else {
                        listDevices += (', ' + device.label)
                      }
                    }
                  });
                  temp.getTracks().forEach(function (track) {
                    track.stop()
                  })
                  return listDevices ? listDevices : this.$t("results.unknown")
                }.bind(this))
                .catch(function (error) {
                  throw error
                })
          }.bind(this))
          .catch(function (error) {
            throw error
          })
    },

    testCamMicro() {
      return navigator.mediaDevices.getUserMedia({"audio": true, "video": true})
          .then(media => {
            this.video = document.querySelector('video')
            this.video.srcObject = media
            this.video.play()
            //return
          })
          .catch(function (error) {
            throw error
          })
    },

    testCamMicroFin() {
      if (this.video.srcObject != null) {
        this.video.srcObject.getTracks().forEach(function (track) {
          track.stop()
        })
      }
    },

    testNav() {
      /*return new Promise((resolve) => {
        let UA = window.navigator.userAgent
        let curOS = Bowser.parse(UA)
        resolve({ UA: UA, curOS: curOS })
      })*/
      return this.getUA()
          .then(UA => {
            let curOS = Bowser.parse(UA)
            return {UA: UA, curOS: curOS}
          })
          .catch(function (error) {
            throw error
          })
    },
  },
}
</script>

<style lang="scss">
@import "../utilities/variables";

.accordion {
  background-color: $accordion-background-color;
  color: $text-color;
  cursor: pointer;
  padding: 0px;
  width: 85%;
  text-align: left;
  //border: none;
  outline: none;
  transition: 0.4s;
  //margin-left: auto;
  //margin-right: auto;
  overflow: hidden;
  margin-bottom: 5em;
}

h1 {
  margin: 0;
  line-height: 2;
  text-align: center;
}

h2 {
  margin: 0 0 .5em;
  font-weight: normal;
}

h3,
h4,
h5,
h6 {
  margin-top: 0;
  margin-bottom: 0.66em
}

video {
  display: block;
  margin: auto;
}
</style>
